<template>
  <div style="flex:1; padding:20px">
    <el-row>
  <h2 style="float:left; margin-left:15px">Users</h2>
<br>
      <el-button style="float:right; margin-right:30px" @click="Create()">Create</el-button>
    </el-row>
    <br />
    <el-card>
      <el-table v-loading="loading" :data="partnerUsers" class="border">
        <el-table-column prop="name" label="Name"></el-table-column>
        <el-table-column prop="surname" label="Surname"></el-table-column>
        <el-table-column prop="email" label="Email"></el-table-column>
        <el-table-column prop="phone" label="Phone"></el-table-column>
        <el-table-column label="Actions">
          <template slot-scope="scope">
            <el-button @click="Edit(scope.row._id)">Edit</el-button>
            <el-button type="danger" @click="Delete(scope.row._id)">Detele</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog width="30%" vtitle="Edit Point" :visible.sync="showForm">
      <el-form ref="form" :model="form" :rules="rules" v-loading="formLoading" label-width="100px">
  
        <el-form-item label="Name" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="Surname" prop="surname">
          <el-input v-model="form.surname"></el-input>
        </el-form-item>
        <el-form-item label="Phone" prop="phone">
          <el-input v-model="form.phone"></el-input>
        </el-form-item>
        <hr />
        <p>PartnerUser will be login with below credentials</p>

        <el-form-item label="Email" prop="email">
          <el-input v-model="form.email"></el-input>
        </el-form-item>
        <el-form-item v-if="!this.editId" label="password" prop="password">
          <el-input type="password" v-model="form.password"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button v-if="!this.editId" type="primary" @click="CreatePartnerUser()">Create</el-button>
          <el-button v-if="this.editId" type="primary" @click="UpdatePartnerUser()">Update</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>



<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "PartnerUser",
  data() {
    return {
     
      formLoading: false,
      showForm: false,
      editId: "",
      form: {
        name: "",
        surname: "",
        phone: "",
        email: "",
        password: ""
      },
      rules: {
        name: [
          { required: true, message: "Please input name", trigger: "blur" }
        ],
        surname: [
          { required: true, message: "Please input surname", trigger: "blur" }
        ],
       
        email: [
          {
            required: true,
            message: "Please input email",
            trigger: "blur"
          }
        ],
        password: [
          { required: true, message: "Please input password", trigger: "blur" }
        ]
      }
    };
  },
  created() {
    this.getPartnerUsers();
  },
  computed: {
    ...mapState("partnerUser", ["partnerUsers", "loading"])
  },
  methods: {
    ...mapActions("partnerUser", ["createPartnerUser", "updatePartnerUser", "deletePartnerUser"]),
    ...mapActions("partnerUser", ["getPartnerUsers"]),
    CreatePartnerUser() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.formLoading = true;
          this.createPartnerUser(this.form)
            .then(() => {
              this.formLoading = false;
              this.showForm = false;
            })
            .finally(() => (this.formLoading = false));
        }
      });
    },
    Delete(id) {
      this.$confirm(
        "This will permanently delete the partnerUser. Continue?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning"
        }
      )
        .then(() =>
          this.deletePartnerUser(id)
        )
        .catch(() => {
          this.$message({
            type: "info",
            message: "Delete canceled"
          });
        });
    },
    UpdatePartnerUser() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.formLoading = true;
          this.form.id = this.editId;
          this.updatePartnerUser(this.form)
            .then(() => {
              this.formLoading = false;
              this.showForm = false;
            })
            .finally(() => (this.formLoading = false));
        }
      });
    },
    Create() {
      this.editId = undefined;
      this.showForm = true;
    },
    Edit(id) {
      this.editId = id;
      const partnerUser = this.partnerUsers.find(x => x._id == id);
      if (partnerUser) {
        this.form.name = partnerUser.name;
        this.form.surname = partnerUser.surname;
        this.form.phone = partnerUser.phone;
        this.form.email = partnerUser.email;
        this.form.password = partnerUser.password;
      }
      this.showForm = true;
    },
    
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>
<style scoped>
.container {
  padding: 20px;
  margin-top: 0px;
  flex: 1;
  display: flex;
}
.tree-container {
  flex-basis: 20%;
  border: 1.5px solid #e4e7ed;
  margin-right: 10px;
}
.tabs {
  flex-basis: 80%;
  display: flex;
}
</style>